import { showModerationToast } from '../Components/Toast/toast';

export const CONTENT_MODERATION_BLOCKED = 'CONTENT_MODERATION_BLOCKED';

export const MODERATION_DEFAULT_MESSAGE =
  'This content violates our community guidelines. Please update and try again.';

export function normalizeApiError(error) {
  return error?.response?.data ?? error;
}

export function isContentModerationBlocked(error) {
  const data = normalizeApiError(error);
  return data?.code === CONTENT_MODERATION_BLOCKED;
}

export function getModerationMessage(error) {
  const data = normalizeApiError(error);
  return data?.message || MODERATION_DEFAULT_MESSAGE;
}

export function applyValidationErrorsToFormik(errors, setFieldError) {
  if (!errors || typeof errors !== 'object' || !setFieldError) return;

  Object.entries(errors).forEach(([field, value]) => {
    const message = Array.isArray(value) ? value[0] : value;
    if (message) {
      setFieldError(field, message);
    }
  });
}

/**
 * Shared handler for signup/profile/media API errors.
 * Returns: 'moderation' | 'validation' | 'generic'
 */
export function handleSignupApiError(error, options = {}) {
  const data = normalizeApiError(error);

  if (isContentModerationBlocked(error)) {
    const message = getModerationMessage(error);
    showModerationToast(message);
    options.onModerationBlocked?.(message);
    return 'moderation';
  }

  if (data?.errors && typeof data.errors === 'object') {
    options.onValidationError?.(data.errors);
    return 'validation';
  }

  options.onGenericError?.(data?.message || 'Something went wrong. Please try again.');
  return 'generic';
}
